import React from 'react'
import ReactDom from 'react-dom';

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

import BailOutForm from './BailOutForm.jsx'

window.scrolledToProgress = false;
window.lastY = 0;
function Scroll_To(pos)
{
    var y = document.documentElement.scrollTop || document.body.scrollTop;



    y += Math.round( ( pos - y ) * 0.3 );

    // need an additional condition for if we can't scroll any farther...
    // currently easier to just check if we've tried to do the same move as before
    if (Math.abs(y-pos) <= 2 || y == window.lastY)
    {
      document.documentElement.scrollTop = pos;
      document.body.scrollTop = pos;
        return;
    }

    window.lastY = y;
    document.documentElement.scrollTop = y;
    document.body.scrollTop = y;

    setTimeout(Scroll_To, 40, pos);
}

var PrequalProgress = React.createClass({

 getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);

    if(scrolledToProgress) {
      return;
    }

    var a = ReactDom.findDOMNode(this), b = 0, c = 0;
    while (a) {
        b += a.offsetLeft;
        c += a.offsetTop;

        a = a.offsetParent;
    }


    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if(w < 768) {
      c -= 90;
    }


    Scroll_To(c);
    window.scrolledToProgress = true;
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  videoPlay() {
    AvailabilityActions.setVideoPlaying(true);
  },
  videoPause() {
    AvailabilityActions.setVideoPlaying(false);
  },
  videoEnd() {
    AvailabilityActions.setVideoPlaying(false);
  },

  continuePrequal() {
    this.state.store = this.state.store.set('prequal_stage', 0);
    this.state.store = this.state.store.set('bailOutForm', false);
    AvailabilityActions.setBailOutForm(false);
    AvailabilityActions.setPrequalStage(0);
    AvailabilityActions.setVideoPlaying(false);
    AvailabilityActions.continuePrequal(this.state.store.get('lastPrequal').toJS());
  },


  render() {
    const { t } = this.props;
    var store = this.state.store;


    var continueButton, spinner;

    spinner = <img src={store.get('install_path')+"/img/building-loader.gif"} className="spinner" alt="Offers are loading..." />;

    const timeStm = Math.floor(Date.now() / (1000*60*5)); // Switch image every 5 minutes
    if(store.get('prequal_stage') == 9) {
        continueButton = <button type="submit" className="btn btn-primary btn-lg continue-button" onClick={this.continuePrequal}>{t('common:continue')}</button>
        spinner = "";
      }

    let header;
    if(store.get('qualTempUnavail')) {
        header =   "";
        spinner = "";
    } else {
        header =   <h1>{t('common:prequal_stage_'+store.get('prequal_stage')+'_header')}</h1>;
    }

    var address = {
      address: store.getIn(['input_address', 'streetAddress']),
      unit: store.getIn(['input_address', 'secondary']),
      city: store.getIn(['input_address', 'city']),
      human_city: store.getIn(['input_address', 'human_city']),
      state: store.getIn(['input_address', 'state']),
      zip: store.getIn(['input_address', 'zip']),
      serviceType: store.getIn(['input_address', 'serviceType'])
    }

    address.human_city ? address.human_city : address.city;

    if(address.unit) {
      address.address = address.address + ' ' + address.unit;
    }
    delete address.unit;

    return (
      <div className="text-center prequal-progress">
        <div className="prequal-input-display">{t('common:you_entered')} <span className="text-nowrap address-only"> {address.address}, {address.human_city} {address.state} {address.zip}</span>, {t('common:for_'+address.serviceType)}</div>

        {header}
        {spinner}

        {continueButton}

        <BailOutForm />

      </div>

    );
  }
});

export default  translate('common', { wait: true })(PrequalProgress);